import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import "./assets/css/styles.css";
import "./assets/css/colors.css";
import "./assets/css/rtl.css";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import { definePreset } from "@primeuix/themes";

import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import Skeleton from "primevue/skeleton";
import Accordion from "primevue/accordion";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import Slider from "primevue/slider";

// Import locale messages
import en from "./locales/en.json";
import ar from "./locales/ar.json";

const CustomAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#f9f6f0",
      100: "#f3ede1",
      200: "#e7dbc3",
      300: "#dbc9a5",
      400: "#c7ab6c", // Lighter gold shade
      500: "#c7ab6c", // Lighter gold shade
      600: "#9a8751", // Darker gold
      700: "#91783e",
      800: "#7a6732",
      900: "#5c532d",
      950: "#2d2916",
    },
    dark: {
      50: "#e6e6e6",
      100: "#cccccc",
      200: "#999999",
      300: "#666666",
      400: "#333333",
      500: "#000000", // Pure black
      600: "#000000",
      700: "#000000",
      800: "#000000",
      900: "#000000",
      950: "#000000",
    },
  },
});

import $ from "jquery";
window.$ = $;

const pinia = createPinia();
const head = createHead();

// Determine initial locale from localStorage or default to 'ar'
const initialLocale = localStorage.getItem("lang") || "ar";

// Create i18n instance with options
const i18n = createI18n({
  legacy: false, // Recommended for Vue 3
  locale: initialLocale, // set initial locale from localStorage or default
  fallbackLocale: "ar", // set fallback locale to Arabic
  messages: {
    en,
    ar,
  }, // set locale messages
});

// Set document direction based on language
document.documentElement.lang = initialLocale;
document.documentElement.dir = initialLocale === "ar" ? "rtl" : "ltr";

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(head);
app.use(i18n); // Use i18n instance
app.use(PrimeVue, {
  theme: {
    preset: CustomAura,
    options: {
      primary: "#c7ab6c", // Set primary color to lighter gold
      dark: "#000000", // Set dark color to black
      darkModeSelector: ".fake-dark-selector",
    },
  },
});
app.use(ToastService);
app.component("AutoComplete", AutoComplete);
app.component("Button", Button);
app.component("Toast", Toast);
app.component("Skeleton", Skeleton);
app.component("AccordionPanel", AccordionPanel);
app.component("Accordion", Accordion);
app.component("AccordionHeader", AccordionHeader);
app.component("AccordionContent", AccordionContent);
app.component("Slider", Slider);

app.mount("#app");
